import {SocketApi} from "proto_socket_typescript";
import {MladiVoznikStore} from "./mladi_voznik_store";
import {cvv_types, mladi_voznik} from "../proto/compiled";
import {DateFormatters} from "../utils";
import {makeAutoObservable} from "mobx";

export class MladiVoznikStoreS3 {
    api: SocketApi;
    base: MladiVoznikStore;
    datumIzdajeVozniske?: Date;
    datumIzdajeVozniskeEdited: boolean = false;
    datumOpravljenegaIntenzivnegaTecaja?: Date;
    datumNapotila?: Date;
    datumOpravljenegaIntenzivnegaTecajaEdited: boolean = false;
    datumNapotilaEdited: boolean = false;
    kazenskeSoglasje: boolean = false;

    constructor(base: MladiVoznikStore, api: SocketApi) {
        this.api = api;
        this.base = base;
        if (this.base.form.step2?.date?.dateTime?.ts) {
            this.datumIzdajeVozniske = new Date(this.base.form.step2!.date!.dateTime!.ts as number);
        } else {
            this.datumIzdajeVozniske = new Date();
        }
        if (this.base.form.step3?.datumOpravljenegaIntenzivnegaTecaja?.ts) {
            this.datumOpravljenegaIntenzivnegaTecaja = new Date(this.base.form.step3.datumOpravljenegaIntenzivnegaTecaja.ts as number);
        }
        if (this.base.form.step3?.napotiloDatum?.ts) {
            this.datumNapotila = new Date(this.base.form.step3.napotiloDatum.ts as number);
        }
        if (!this.base.form.step3?.veljavnoVoznisko) {
            this.base.form.step3!.napotilo = mladi_voznik.KazenskeTockeNapotilo.zdravstveni_pregled;
        }
        makeAutoObservable(this);
    }

    init() {
    }

    dispose() {
    }

    get done(): boolean {
        return true;
    };

    datumIzdajeValidator(ignore: boolean, tecajDateTs?: number) {
        tecajDateTs ??= Date.now();
        const tecajDate = new Date(tecajDateTs);
        if (ignore && !this.datumIzdajeVozniskeEdited) return undefined;
        if (!this.base.form.step3!.datumIzdajeVozniske) return 'Vnesite veljaven datum.';
        const age = tecajDate.getTime() - (this.base.form.step3!.datumIzdajeVozniske.ts as number);

        const tecajMinus6M = new Date(tecajDate.getTime());
        tecajMinus6M.setMonth(tecajMinus6M.getMonth() - 6);
        const tecajMinus6MAge = tecajDate.getTime() - tecajMinus6M.getTime();
        if (age < tecajMinus6MAge) return 'Od izdaje vozniškega dovoljenja do datuma opravljanja tečaja mora miniti vsaj 6 mesecev.';
        return undefined;
    }

    datumOpravljenegaIntenzivnegaTecajaValidator(ignore: boolean) {
        if (ignore && !this.datumOpravljenegaIntenzivnegaTecajaEdited) return undefined;
        if (!this.base.form.step3!.datumOpravljenegaIntenzivnegaTecaja) return 'Vnesite veljaven datum.';
        if (this.base.form.step3!.datumOpravljenegaIntenzivnegaTecaja.ts as number >= Date.now()) {
            return 'Datum opravljenega intenzivnega tečaja mora biti v preteklosti!';
        }
        return undefined;
    }

    datumNapotilaValidator(ignore: boolean) {
        if (ignore && !this.datumNapotilaEdited) return undefined;
        if (!this.base.form.step3!.napotiloDatum) return 'Vnesite veljaven datum.';
        if (this.base.form.step3!.napotiloDatum.ts as number >= Date.now()) {
            return 'Datum napotila mora biti v preteklosti!';
        }
        return undefined;
    }

    setDatumIzdajeVozniske(value?: Date) {
        this.datumIzdajeVozniske = value;
        this.datumIzdajeVozniskeEdited = true;
        if (value) {
            this.base.form.step3!.datumIzdajeVozniske = new cvv_types.Date({ts: value.getTime()});
        } else {
            this.base.form.step3!.datumIzdajeVozniske = null;
        }
    }

    setDatumOpravljenegaIntenzivnegaTecaja(value?: Date) {
        this.datumOpravljenegaIntenzivnegaTecaja = value;
        this.datumOpravljenegaIntenzivnegaTecajaEdited = true;
        if (value) {
            this.base.form.step3!.datumOpravljenegaIntenzivnegaTecaja = new cvv_types.Date({ts: value.getTime()});
        } else {
            this.base.form.step3!.datumOpravljenegaIntenzivnegaTecaja = null;
        }
    }

    setDatumNapotila(value?: Date) {
        this.datumNapotila = value;
        this.datumNapotilaEdited = true;
        if (value) {
            this.base.form.step3!.napotiloDatum = new cvv_types.Date({ts: value.getTime()});
        } else {
            this.base.form.step3!.napotiloDatum = null;
        }
    }
}
